import { render } from "./ModalHelper.vue?vue&type=template&id=47775109&scoped=true"
import script from "./ModalHelper.vue?vue&type=script&lang=js"
export * from "./ModalHelper.vue?vue&type=script&lang=js"

import "./ModalHelper.vue?vue&type=style&index=0&id=47775109&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47775109"]])

export default __exports__